<div class="card settings-page">
  <ul class="list-unstyled connection-group-list">
    @for (connectionGroup of connectionGroups; track connectionGroup) {
      @if (connectionGroup.connections.length) {
        <li class="connection-group">
          <div class="connection-group-title">{{ connectionGroup.title }}</div>

          <ul class="list-unstyled connections-list">
            @for (connection of connectionGroup.connections; track connection) {
              <li class="connection-item">
                <app-connection-card
                  [connection]="connection"
                  [isLoading]="loadingBtn || isLoading()"
                />
              </li>
            }
          </ul>
        </li>
      }
    }
  </ul>
</div>
